export const getIndex = (data, page) => {
  return data.findIndex((val) => val?.page == page);
};
